import { graphql, httpClient, resolveApiUrl } from '#shared/api'
import GetOrderListResponse from '../model/get-order-list-response'

interface GetOrderListOptions {
  after?: string | null
  isCurrent?: boolean
  count?: number
}

export default async function getOrderList({ after, isCurrent, count = 20 }: GetOrderListOptions) {
  const currentStatuses = '[ARRIVING, PROCESSING]'
  const historyStatuses = '[FINISHED, CANCELLED]'

  const queryStatuses = isCurrent ? currentStatuses : historyStatuses

  const response = await httpClient.post<GetOrderListResponse>(resolveApiUrl('@sd-orders'), {
    json: graphql(
      `
      query($count: Int!, $after: String) {
        ordersByStaffIds(first: $count, after: $after, where: { status: { in: ${queryStatuses} } }, order: [{ createdAt: DESC }]) {
          nodes {
            createdAt
            id
            clientId
            status
            totalReward {
              amount
              currency
            }
            staffArrivalTime
          }

          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }`,
      {
        count,
        after,
      }
    ),
  })

  const responseBody = await response.json()
  return responseBody.data.ordersByStaffIds
}
